
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/account/change-password",
      function () {
        return require("private-next-pages/[locale]/account/change-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/account/change-password"])
      });
    }
  